const show_closed_tabs_default_to_false = {
  8: (state) => {
    return {
      ...state,
      search: {
        ...(state?.search ?? {}),
        showClosedTabs: false,
      }
    }
  },
}

export default show_closed_tabs_default_to_false
